// extracted by mini-css-extract-plugin
export default {"button":"TextButton_button__zOtTa","focus":"TextButton_focus__lnyrO","leading":"TextButton_leading__K25VV","trailing":"TextButton_trailing__tLIL0","text":"TextButton_text__8CiGa"};